import {institutionServiceFields} from "../service/service.graphql";
import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const GET_ALL_INSTITUTION_SERVICE = gql`
  query GetInstitutionServices($filtering: ServiceInstitutionFilterInputObject) {
    getInstitutionServices(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`
